var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            { class: _vm.isMobile ? "pa-0" : "" },
            [
              _c(
                "v-layout",
                { class: _vm.isMobile ? "pa-0" : "", attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { class: _vm.isMobile ? "pa-0" : "", attrs: { xs12: "" } },
                    [
                      _c("custom-table", {
                        ref: "customTable",
                        attrs: {
                          "data-url": "/quotations/versions",
                          "single-item-name": "version",
                          "plural-item-name": "versions",
                          headers: _vm.headers,
                          "additional-data": {
                            id: _vm.$route.params.quotationId
                          },
                          breakpoint: 950,
                          "filter-button": false,
                          clickable: "",
                          flat: ""
                        },
                        on: { click: _vm.view },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "row",
                              fn: function(props) {
                                return [
                                  _c("td", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(props.item.name) +
                                        "\n                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.checkNested(
                                        props.item,
                                        "client",
                                        "name"
                                      )
                                        ? [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(props.item.client.name) +
                                                "\n                            "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(props.item.reference_number) +
                                        " "
                                    ),
                                    _c("br")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-center" },
                                    [
                                      _vm.checkNested(
                                        props.item,
                                        "total_premium"
                                      ) &&
                                      _vm.checkNested(
                                        props.item,
                                        "monthly_payment"
                                      )
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "currency"
                                                                  )(
                                                                    props.item
                                                                      .total_premium
                                                                  )
                                                                ) +
                                                                "\n                                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                    Total Monthly Payment: " +
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        props.item
                                                          .monthly_payment
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(props.item.version) +
                                        "\n                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-center" },
                                    [
                                      _vm.checkNested(
                                        props.item,
                                        "selected_lpp_label"
                                      )
                                        ? [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  props.item.selected_lpp_label
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                            Created at: " +
                                        _vm._s(
                                          _vm._f("date")(props.item.created_at)
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("fromNow")(
                                            props.item.created_at
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "card",
                              fn: function(props) {
                                return _vm._l(_vm.headers, function(
                                  header,
                                  headerIndex
                                ) {
                                  return _c(
                                    "td",
                                    {
                                      key: headerIndex,
                                      staticClass: "v-data-table__mobile-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "v-data-table__mobile-row__header"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(header.text) +
                                              "\n                            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "v-data-table__mobile-row__cell"
                                        },
                                        [
                                          header.value === "client_name"
                                            ? [
                                                _vm.checkNested(
                                                  props.item,
                                                  "client",
                                                  "name"
                                                )
                                                  ? [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            props.item.client
                                                              .name
                                                          ) +
                                                          "\n                                    "
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ]
                                            : header.value === "premium"
                                            ? [
                                                _vm.checkNested(
                                                  props.item,
                                                  "total_premium"
                                                )
                                                  ? [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              props.item
                                                                .total_premium
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c("br")
                                                    ]
                                                  : _vm._e()
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$refs.customTable.getCardValue(
                                                        props.item,
                                                        header.value
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                })
                              }
                            }
                          ],
                          null,
                          false,
                          4002746788
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }